import { Helmet } from 'react-helmet';
import Careers from '../components/Careers';

export default function CareersPage() {
  return (
    <>
      <Helmet>
        <title>Careers | The Prisu Experts</title>
        <meta
          name="description"
          content="Join The Prisu Experts’ global network of contributors and professionals building the future of AI."
        />
      </Helmet>
      <Careers />
    </>
  );
}
